
import Vue from 'vue';
import CloseIcon from '../../../Icons/CloseIcon.vue';

export default Vue.extend<any, any, any, any>({
  name: 'TagContainer',
  components: {
    CloseIcon
  },
  props: {
    /**
     * Set id
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set color for delete icon
     */
    deleteColor: {
      type: String,
      default: '#d3dded'
    }
  },
  methods: {
    handleClick(e: any) {
      /**
       * Method to click the tag's close icon
       * @event click
       * @type {function}
       * @title {cobadeh}
       */
      this.$emit('click', e);
    }
  }
});
